/* Elite EG: "اطلبي دلوقتي" on the product page opens the store's own short cash-on-delivery form
   (snippets/elite-buy.liquid). The form posts to the CRM, which creates the real Shopify order and
   answers with its number. Card / InstaPay payers follow the link to the ordinary checkout (cart
   permalink), and the form falls back to that checkout if the CRM cannot be reached. The Elite bar
   at the bottom of phones opens the same form. Styles: assets/elite-product.css + assets/elite-form.css. */
(function () {
  var ar = (document.documentElement.lang || '').slice(0, 2) === 'ar';
  var T = ar ? {
    off: 'خلصت', main: 'اطلبي دلوقتي', sending: 'ثواني…', name: 'اكتبي اسمك', phone: 'اكتبي رقم موبايل صح (11 رقم يبدأ بـ 01)',
    governorate: 'اختاري المحافظة', address: 'اكتبي العنوان بالتفصيل', sold_out: 'للأسف اللون أو المقاس ده خلص.',
    fallback: 'حصلت مشكلة بسيطة، هنكمّل طلبك من صفحة الدفع العادية…', pound: 'ج', wa: 'طلب رقم '
  } : {
    off: 'Sold out', main: 'Order now', sending: 'One moment…', name: 'Please enter your name', phone: 'Enter a valid mobile (11 digits starting 01)',
    governorate: 'Choose your governorate', address: 'Please enter your full address', sold_out: 'Sorry, this colour or size is sold out.',
    fallback: 'Small hiccup, taking you to the regular checkout…', pound: 'EGP', wa: 'Order '
  };

  function form() {
    return document.querySelector('product-info form[action*="/cart/add"], .product__info-container form[action*="/cart/add"], form[action*="/cart/add"]');
  }
  function variantId() {
    var f = form();
    var input = f && f.querySelector('input[name="id"]');
    var id = input ? input.value : new URLSearchParams(location.search).get('variant');
    return id ? String(id).trim() : '';
  }
  /* Dawn disables its add-to-cart button when the chosen variant is sold out or does not exist */
  function available() {
    var atc = document.querySelector('.product-form__submit');
    return !(atc && atc.disabled);
  }
  function permalink(root, path, qty) {
    var id = variantId();
    if (!id) return '';
    return root + '/' + id + ':' + (qty || 1) + '?attributes[elite_path]=' + (path || 'buy_now');
  }
  function money(n) {
    var s = Math.round(n).toLocaleString(ar ? 'ar-EG' : 'en-US');
    return ar ? s + ' ' + T.pound : T.pound + ' ' + s;
  }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  /* first page of this visit (and its ad-click ids), for ad attribution of the order */
  try {
    if (!sessionStorage.getItem('el_landing')) sessionStorage.setItem('el_landing', location.href);
    var qs = new URLSearchParams(location.search);
    if (qs.get('fbclid')) sessionStorage.setItem('el_fbclid', qs.get('fbclid'));
    if (qs.get('ttclid')) sessionStorage.setItem('el_ttclid', qs.get('ttclid'));
  } catch (e) {}
  function cookie(k) { var m = document.cookie.match('(?:^|; )' + k + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function clickIds() {
    var o = { fbp: cookie('_fbp'), fbc: cookie('_fbc'), ttp: cookie('_ttp'), ttclid: '' };
    try {
      var fbclid = sessionStorage.getItem('el_fbclid');
      if (!o.fbc && fbclid) o.fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      o.ttclid = sessionStorage.getItem('el_ttclid') || '';
    } catch (e) {}
    return o;
  }

  /* ---------- data from the snippet ---------- */
  var D = null;
  try { var dj = document.querySelector('[data-el-form-data]'); D = dj ? JSON.parse(dj.textContent) : null; } catch (e) { D = null; }
  function variant() {
    var id = variantId();
    if (!D) return null;
    for (var i = 0; i < D.variants.length; i++) if (String(D.variants[i].id) === id) return D.variants[i];
    return null;
  }
  function gov(key) {
    if (!D) return null;
    for (var i = 0; i < D.govs.length; i++) if (D.govs[i][0] === key) return { key: key, ar: D.govs[i][1], en: D.govs[i][2], zone: D.govs[i][3], shipping: D.shipping[String(D.govs[i][3])] };
    return null;
  }
  function variantById(id) {
    if (!D) return null;
    for (var i = 0; i < D.variants.length; i++) if (String(D.variants[i].id) === String(id)) return D.variants[i];
    return null;
  }
  function offerOff(pieces) {
    if (!D || pieces < 2) return 0;
    if (Date.now() > Date.parse(D.offersEnd)) return 0;
    return D.offers[D.handle] || 0;
  }
  var MAX_LINES = 5, MAX_PIECES = 10;

  /* ---------- the sheet ---------- */
  var sheet = null, root = '/cart', busy = false;
  var lines = []; /* [{id, qty}] one per colour/size */
  var el = {};
  function q(sel) { return sheet ? sheet.querySelector(sel) : null; }
  function initSheet() {
    sheet = document.querySelector('[data-el-form]');
    if (!sheet || !D) { sheet = null; return; }
    /* Dawn's product info wrapper is transformed, which would pin a fixed sheet to it instead of the screen */
    if (sheet.parentNode !== document.body) document.body.appendChild(sheet);
    el.form = q('[data-el-form-form]'); el.done = q('[data-el-form-done]');
    el.lines = q('[data-el-form-lines]'); el.add = q('[data-el-form-add]'); el.tpl = q('[data-el-form-line-tpl]');
    el.sumQty = q('[data-el-form-sum-qty]'); el.sumItems = q('[data-el-form-sum-items]');
    el.offerRow = q('[data-el-form-sum-offer-row]'); el.offer = q('[data-el-form-sum-offer]');
    el.ship = q('[data-el-form-sum-ship]'); el.total = q('[data-el-form-sum-total]');
    el.alert = q('[data-el-form-alert]'); el.submit = q('[data-el-form-submit]'); el.ctaMain = q('[data-el-form-cta-main]');
    el.card = q('[data-el-form-card]'); el.doneNo = q('[data-el-form-done-no]'); el.doneWa = q('[data-el-form-done-wa]');
    el.f = {};
    ['name', 'phone', 'governorate', 'address', 'notes'].forEach(function (k) { el.f[k] = q('[data-el-form-field="' + k + '"]'); });

    /* governorates */
    var sel = el.f.governorate;
    D.govs.forEach(function (g) {
      var o = document.createElement('option');
      o.value = g[0]; o.textContent = ar ? g[1] : g[2];
      sel.appendChild(o);
    });
    liveShipping();
    /* remembered details (same governorate key as the shipping box) */
    el.f.name.value = store('el_form_name') || '';
    el.f.phone.value = store('el_form_phone') || '';
    el.f.address.value = store('el_form_address') || '';
    var g0 = store('elShipGov'); if (g0 && gov(g0)) sel.value = g0;

    sheet.querySelectorAll('[data-el-form-close]').forEach(function (b) { b.addEventListener('click', close); });
    el.add.addEventListener('click', addLine);
    sel.addEventListener('change', function () { store('elShipGov', sel.value); clearBad('governorate'); sum(); });
    ['name', 'phone', 'address'].forEach(function (k) { el.f[k].addEventListener('input', function () { clearBad(k); }); });
    el.form.addEventListener('submit', submit);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-on')) close(); });
  }
  function pieces() { var n = 0; for (var i = 0; i < lines.length; i++) n += lines[i].qty; return n; }
  function addLine() {
    if (lines.length >= MAX_LINES || pieces() >= MAX_PIECES) return;
    var used = {}; lines.forEach(function (l) { used[l.id] = 1; });
    var next = null;
    for (var i = 0; i < D.variants.length; i++) if (D.variants[i].available && !used[D.variants[i].id]) { next = D.variants[i]; break; }
    if (!next) next = variantById(lines[0].id);
    lines.push({ id: String(next.id), qty: 1 });
    renderLines();
    var sel = el.lines.querySelectorAll('[data-el-form-line-variant]');
    try { sel[sel.length - 1].focus(); } catch (e) {}
  }
  function renderLines() {
    el.lines.innerHTML = '';
    lines.forEach(function (line, idx) {
      var node = el.tpl.content.firstElementChild.cloneNode(true);
      var v = variantById(line.id) || D.variants[0];
      var sel = node.querySelector('[data-el-form-line-variant]');
      D.variants.forEach(function (pv) {
        if (!pv.available && String(pv.id) !== line.id) return;
        var o = document.createElement('option');
        o.value = String(pv.id); o.textContent = pv.title === 'Default Title' ? D.title : pv.title;
        sel.appendChild(o);
      });
      sel.value = line.id;
      sel.addEventListener('change', function () { line.id = sel.value; renderLines(); });
      node.querySelector('[data-el-form-img]').src = v.image || D.image;
      node.querySelector('[data-el-form-unit]').textContent = money(v.price);
      node.querySelector('[data-el-form-qty]').value = line.qty;
      node.querySelector('[data-el-form-minus]').addEventListener('click', function () { if (line.qty > 1) { line.qty--; renderLines(); } });
      node.querySelector('[data-el-form-plus]').addEventListener('click', function () { if (pieces() < MAX_PIECES) { line.qty++; renderLines(); } });
      node.querySelector('[data-el-form-rm]').addEventListener('click', function () { lines.splice(idx, 1); renderLines(); });
      node.classList.toggle('is-one', lines.length === 1);
      el.lines.appendChild(node);
    });
    el.add.hidden = lines.length >= MAX_LINES || pieces() >= MAX_PIECES || D.variants.filter(function (pv) { return pv.available; }).length < 2 && lines.length >= 1 && pieces() >= MAX_PIECES;
    sum();
  }
  /* shipping prices as set in Shopify now (the CRM reads them), so a change there needs no theme edit */
  function liveShipping() {
    try {
      var u = String(D.api || '').replace(/\/order(\?.*)?$/, '/shipping');
      if (!u || u === D.api || !window.fetch) return;
      fetch(u, { mode: 'cors', credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (!j || !j.zones) return;
        for (var z in j.zones) if (typeof j.zones[z] === 'number' && j.zones[z] >= 0) D.shipping[z] = j.zones[z];
        if (lines.length) sum();
      }).catch(function () {});
    } catch (e) {}
  }
  function cartPath() {
    return lines.map(function (l) { return l.id + ':' + l.qty; }).join(',');
  }
  function sum() {
    var g = gov(el.f.governorate.value);
    var items = 0;
    lines.forEach(function (l) { var v = variantById(l.id); if (v) items += v.price * l.qty; });
    var n = pieces(), off = offerOff(n);
    el.sumQty.textContent = n > 1 ? '× ' + n : '';
    el.sumItems.textContent = money(items);
    el.offerRow.hidden = !off;
    el.offer.textContent = off ? '− ' + money(off) : '';
    el.ship.textContent = g ? money(g.shipping) : (ar ? 'حسب المحافظة' : 'by governorate');
    el.total.textContent = money(items - off + (g ? g.shipping : 0));
    el.card.href = root + '/' + cartPath() + '?attributes[elite_path]=buy_now';
  }
  var lastVid = '';
  function fill() {
    var v = variant();
    if (!v) return;
    lastVid = String(v.id);
    /* the first line follows the colour/size chosen on the page; extra lines stay */
    if (!lines.length) lines.push({ id: lastVid, qty: 1 });
    else lines[0].id = lastVid;
    renderLines();
  }
  function open() {
    if (!sheet || !available()) return;
    fill();
    el.form.hidden = false; el.done.hidden = true;
    note('');
    sheet.hidden = false;
    document.documentElement.classList.add('el-form-open');
    requestAnimationFrame(function () { sheet.classList.add('is-on'); });
    var first = !el.f.name.value ? el.f.name : (!el.f.phone.value ? el.f.phone : null);
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 300);
    track('InitiateCheckout', null);
  }
  function close() {
    if (!sheet || busy) return;
    sheet.classList.remove('is-on');
    document.documentElement.classList.remove('el-form-open');
    setTimeout(function () { sheet.hidden = true; }, 280);
  }
  function note(msg, info) {
    if (!el.alert) return;
    el.alert.textContent = msg || '';
    el.alert.hidden = !msg;
    el.alert.classList.toggle('is-info', !!info);
  }
  function bad(k, msg) {
    var f = el.f[k]; if (!f) return;
    var wrap = f.closest('.el-form__field');
    wrap.classList.add('is-bad');
    var em = wrap.querySelector('em'); if (em) em.textContent = msg || T[k] || '';
    if (!bad.first) { bad.first = f; }
  }
  function clearBad(k) {
    var f = el.f[k]; if (!f) return;
    f.closest('.el-form__field').classList.remove('is-bad');
  }
  function phoneOk(raw) {
    var s = String(raw || '').replace(/[٠-٩]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'.indexOf(d); }).replace(/[^\d+]/g, '');
    if (s.indexOf('+20') === 0) s = '0' + s.slice(3);
    else if (s.indexOf('0020') === 0) s = '0' + s.slice(4);
    else if (s.indexOf('20') === 0 && s.length === 12) s = '0' + s.slice(2);
    else if (/^1[0125]\d{8}$/.test(s)) s = '0' + s;
    return /^01[0125]\d{8}$/.test(s) ? s : '';
  }
  function validate() {
    bad.first = null;
    var ok = true;
    if (el.f.name.value.trim().length < 2) { bad('name'); ok = false; }
    if (!phoneOk(el.f.phone.value)) { bad('phone'); ok = false; }
    if (!gov(el.f.governorate.value)) { bad('governorate'); ok = false; }
    if (el.f.address.value.trim().length < 5) { bad('address'); ok = false; }
    if (!ok && bad.first) { try { bad.first.focus({ preventScroll: false }); } catch (e) {} }
    return ok;
  }
  function setBusy(on) {
    busy = on;
    el.submit.disabled = on;
    el.ctaMain.textContent = on ? T.sending : el.ctaMain.getAttribute('data-txt');
  }
  /* tells the CRM's visitor journey (assets/elite-journey.js) why the form didn't finish */
  function failed(why) { try { if (window.elJourney) window.elJourney('form_fail', { why: why }); } catch (x) {} }
  function fallback(why) {
    failed(why || 'shopify');
    note(T.fallback, true);
    var u = lines.length ? root + '/' + cartPath() + '?attributes[elite_path]=form_fallback' : '';
    setTimeout(function () { if (u) location.assign(u); else { setBusy(false); note(''); } }, 1200);
  }
  function submit(e) {
    e.preventDefault();
    if (busy) return;
    note('');
    if (!validate()) return;
    var v = variantById(lines[0].id);
    if (!v || !v.available) { note(T.sold_out); return; }
    if (!el.ctaMain.getAttribute('data-txt')) el.ctaMain.setAttribute('data-txt', el.ctaMain.textContent);
    setBusy(true);
    store('el_form_name', el.f.name.value.trim());
    store('el_form_phone', phoneOk(el.f.phone.value));
    store('el_form_address', el.f.address.value.trim());
    var landing = '';
    try { landing = sessionStorage.getItem('el_landing') || location.href; } catch (x) { landing = location.href; }
    var qty = pieces();
    var body = {
      variant: String(v.id), quantity: lines[0].qty,
      items: lines.map(function (l) { return { variant: l.id, quantity: l.qty }; }),
      name: el.f.name.value.trim(), phone: phoneOk(el.f.phone.value), governorate: el.f.governorate.value,
      address: el.f.address.value.trim(), notes: el.f.notes.value.trim(),
      locale: ar ? 'ar' : 'en', landing: landing, referrer: document.referrer || '', url: location.href
    };
    var ids = clickIds();
    body.fbp = ids.fbp; body.fbc = ids.fbc; body.ttp = ids.ttp; body.ttclid = ids.ttclid;
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    fetch(D.api, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j || {} }; }); })
      .then(function (res) {
        if (timer) clearTimeout(timer);
        var j = res.j;
        if (j.ok && j.name) { done(j, v, body); return; }
        if (j.error === 'sold_out') failed('sold_out');
        if (res.status === 422 && j.field && el.f[j.field]) { setBusy(false); bad(j.field, j.error === 'sold_out' ? T.sold_out : T[j.field]); if (j.error === 'sold_out') note(T.sold_out); try { el.f[j.field].focus(); } catch (x) {} return; }
        if (j.error === 'sold_out') { setBusy(false); note(T.sold_out); return; }
        fallback('shopify');
      })
      .catch(function () { if (timer) clearTimeout(timer); fallback('network'); });
  }
  function done(j, v, body) {
    var g = gov(body.governorate);
    var qty = pieces();
    var items = 0; lines.forEach(function (l) { var pv = variantById(l.id); if (pv) items += pv.price * l.qty; });
    var total = typeof j.total === 'number' ? j.total : items - offerOff(qty) + (g ? g.shipping : 0);
    var ids = lines.map(function (l) { return l.id; });
    el.doneNo.textContent = j.name;
    if (el.doneWa) el.doneWa.href = D.whatsapp + '?text=' + encodeURIComponent(T.wa + j.name);
    el.form.hidden = true; el.done.hidden = false;
    setBusy(false);
    try { sheet.querySelector('.el-form__sheet').scrollTop = 0; } catch (x) {}
    if (!j.duplicate) track('Purchase', { value: total, currency: 'EGP', content_ids: ids, content_type: 'product', num_items: qty, unit: v.price, order: j.name });
  }

  /* ---------- pixels: the Shopify channel pixels only see the official checkout, so the form fires its own ---------- */
  function loadFbq() {
    if (window.fbq || !D.metaPixel) return;
    /* Meta's standard loader, without the automatic PageView (the Shopify channel already sends it) */
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', D.metaPixel);
  }
  function loadTtq() {
    if (window.ttq || !D.tiktokPixel) return;
    !function (w, d, t) { w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent']; ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }; for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { var e = ttq._i[t] || []; for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; }; ttq.load = function (e, n) { var r = 'https://analytics.tiktok.com/i18n/pixel/events.js'; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = n || {}; var o = d.createElement('script'); o.type = 'text/javascript'; o.async = !0; o.src = r + '?sdkid=' + e + '&lib=' + t; var a = d.getElementsByTagName('script')[0]; a.parentNode.insertBefore(o, a); }; ttq.load(D.tiktokPixel); }(window, document, 'ttq');
  }
  function track(evt, data) {
    try {
      loadFbq(); loadTtq();
      var id = data && data.order ? 'elite_form_' + data.order.replace(/\W/g, '') : undefined;
      if (typeof window.fbq === 'function') {
        if (evt === 'Purchase') window.fbq('track', 'Purchase', { value: data.value, currency: data.currency, content_ids: data.content_ids, content_type: data.content_type, num_items: data.num_items }, { eventID: id });
        else window.fbq('track', evt);
      }
      if (window.ttq && typeof window.ttq.track === 'function') {
        if (evt === 'Purchase') window.ttq.track('CompletePayment', { value: data.value, currency: data.currency, contents: lines.map(function (l) { var pv = variantById(l.id); return { content_id: l.id, content_type: 'product', quantity: l.qty, price: pv ? pv.price : data.unit }; }) }, { event_id: id });
        else window.ttq.track(evt);
      }
      if (typeof window.elTrack === 'function') window.elTrack(evt === 'Purchase' ? 'form_order' : 'form_open', { handle: D.handle });
    } catch (e) {}
  }

  /* ---------- product page button ---------- */
  var buy = null, buyMain = null;
  function go() {
    if (!available()) return;
    if (sheet) { open(); return; }
    var u = permalink(root, 'buy_now', 1);
    if (!u) { var atc = document.querySelector('.product-form__submit'); if (atc) atc.click(); return; }
    location.assign(u);
  }
  function initBuy() {
    buy = document.querySelector('[data-el-buy]');
    if (!buy) return;
    root = buy.getAttribute('data-root') || root;
    buyMain = buy.querySelector('[data-el-buy-main]');
    buy.addEventListener('click', function (e) { e.preventDefault(); go(); });
  }
  function syncBuy() {
    if (!buy) return;
    var ok = available();
    buy.classList.toggle('is-off', !ok);
    buy.setAttribute('aria-disabled', ok ? 'false' : 'true');
    if (buyMain) {
      var want = ok ? T.main : T.off;
      if (buyMain.textContent !== want) buyMain.textContent = want;
    }
    var u = permalink(root, 'buy_now', 1);
    if (u && buy.getAttribute('href') !== u) buy.setAttribute('href', u);
    if (sheet && !sheet.hidden && lastVid !== variantId()) fill();
  }

  /* ---------- Elite bar: follows the price of the chosen colour; shown while the buy button is off screen ---------- */
  var bar = null, barNow = null, barWas = null, barBtn = null;
  function syncPrice() {
    if (!bar) return;
    var price = document.querySelector('.product__info-container .price');
    if (!price) return;
    var onSale = price.classList.contains('price--on-sale');
    var cur = onSale ? price.querySelector('.price__sale .price-item--sale') : price.querySelector('.price__regular .price-item--regular');
    var old = onSale ? price.querySelector('.price__sale .price-item--regular') : null;
    var now = cur ? cur.textContent.trim().replace(/[.,]00(?=\D*$)/, '') : '';
    var was = old ? old.textContent.trim().replace(/[.,]00(?=\D*$)/, '') : '';
    if (barNow && now && barNow.textContent !== now) barNow.textContent = now;
    if (barWas && barWas.textContent !== was) { barWas.textContent = was; barWas.hidden = !was; }
    if (barBtn) barBtn.disabled = !available();
  }
  function initBar() {
    bar = document.querySelector('[data-el-bar]');
    var anchor = document.querySelector('[data-el-buy-wrap]') || document.querySelector('.product-form__buttons');
    if (!bar || !anchor) { bar = null; return; }
    barNow = bar.querySelector('[data-el-bar-now]');
    barWas = bar.querySelector('[data-el-bar-was]');
    barBtn = bar.querySelector('[data-el-bar-btn]');
    function show(on) {
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('el-bar-on', on);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { show(!entries[0].isIntersecting); }, { rootMargin: '0px 0px -56px 0px' }).observe(anchor);
    } else {
      show(true);
    }
    barBtn.addEventListener('click', function () {
      if (available()) go();
      else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  var queued = false;
  function fix() { queued = false; syncBuy(); syncPrice(); }
  function queue() { if (queued) return; queued = true; requestAnimationFrame(fix); }
  function start() {
    initBuy();
    initSheet();
    initBar();
    if (!buy && !bar) return;
    fix();
    new MutationObserver(queue).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value', 'class'] });
    document.addEventListener('change', queue, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
